import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';
import { modalURLFromLocation } from '@jwp/ott-ui-react/src/utils/location';
import Button from '@jwp/ott-ui-react/src/components/Button/Button';
import Icon from '@jwp/ott-ui-react/src/components/Icon/Icon';
import ExternalLink from '@jwp/ott-theme/assets/icons/external_link.svg?react';
import env from '@jwp/ott-common/src/env';

import styles from './DeleteAccountModal.module.scss';

const DeleteAccountExternally = () => {
  const { t } = useTranslation('user');
  const navigate = useNavigate();
  const location = useLocation();

  const handeCloseModal = useCallback(() => {
    navigate(modalURLFromLocation(location, null), { replace: true });
  }, [location, navigate]);

  return (
    <form>
      <h2 className={styles.heading}>{t('account.delete_account.title')}</h2>
      <p className={styles.paragraph}>{t('account.delete_account.modal.description_external')}</p>
      <div className={classNames(styles.buttons, styles.stacked)}>
        <a href={env.APP_DELETE_ACCOUNT_URL} style={{ width: '100%' }}>
          <Button type="button" startIcon={<Icon icon={ExternalLink} />} color="primary" onClick={handeCloseModal} label={t('account.continue')} fullWidth />
        </a>
        <Button type="button" variant="text" onClick={handeCloseModal} label={t('account.cancel')} fullWidth />
      </div>
    </form>
  );
};

export default DeleteAccountExternally;
